import R from 'ramda';
import isObject from '@cotyorg/ccx-utils/js/helpers/isObject';

export default ({ categoryName, categories = [] }) => {
  const category = categories.find(({ name }) => name === categoryName);

  return R.compose(
    R.map(name => (isObject(name) ? name : { name })),
    R.propOr([], 'subcategories'),
  )(category);
};
